import CompanyInfo from 'views/CompanyInfo'
import Authorizer from 'views/Authorizer'
import OwnerInfo from 'views/OwnerInfo'
import Payment from 'views/Payment'

const pages = [
	{ title: 'Yrityksen tiedot', short: 'Yritys', Component: CompanyInfo },
	{ title: 'Yhteystiedot', short: 'Yhteystiedot', Component: Authorizer },
	{ title: 'Osakkeenomistajien tiedot', short: 'Osakkaat', Component: OwnerInfo },
	{ title: '', short: 'Maksu', Component: Payment },
]

export default pages
